import * as z from "zod/v4";

export const disconnectRefundidIntegration = {
  name: "disconnectRefundidIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
